export default function Filters({ material, setMaterial }) {
  return (
    <select
      value={material}
      onChange={(e) => setMaterial(e.target.value)}
      className="px-3 py-2 border rounded-lg"
    >
      <option value="">All Materials</option>

      {/* Must match EXACT strings from silverData */}
      <option value="Sterling Silver 92.5%">92.5 Silver</option>
      <option value="Silver + Opal">Silver + Opal</option>
      <option value="Silver + CZ">Silver + CZ</option>
    </select>
  );
}
